'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _applicationState = require('./applicationState');

var _breakpointUtils = require('./breakpointUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTopLevelAttribute = function getTopLevelAttribute(property) {
  var config = (0, _applicationState.getState)(_applicationState.State.config);
  var platformSuffix = (0, _breakpointUtils.getBreakpointName)();
  var platform = platformSuffix ? 'web-' + platformSuffix : 'web';
  var adConfigArray = (0, _get2.default)(config, 'adConfig');
  var platformConfig = (0, _find2.default)(adConfigArray, function (obj) {
    return (0, _find2.default)(obj.platforms, function (value) {
      return value === platform;
    });
  }) || (0, _find2.default)(adConfigArray, function (obj) {
    return (0, _find2.default)(obj.platforms, function (value) {
      return value === 'web';
    });
  });

  return platformConfig[property];
};

var getDefinitionByName = function getDefinitionByName(definitionName, name) {
  var definitions = getTopLevelAttribute(definitionName);
  if (!(0, _isNil2.default)(definitions)) {
    return (0, _first2.default)((0, _filter2.default)(definitions, ['name', name]));
  }
  return undefined;
};

var configUtils = {
  getSlotDefinition: function getSlotDefinition(slotName) {
    return getDefinitionByName('slots', slotName);
  },
  getFormatDefinition: function getFormatDefinition(formatName) {
    return getDefinitionByName('formats', formatName);
  },
  getScreenDefinition: function getScreenDefinition(screenName) {
    return getDefinitionByName('webScreens', screenName);
  },
  getFormatDefinitionsBySlotDefinition: function getFormatDefinitionsBySlotDefinition(slot) {
    var _this = this;

    var formats = [];

    if (slot && slot.formats) {
      (0, _forEach2.default)(slot.formats, function (formatName) {
        var format = _this.getFormatDefinition(formatName);
        formats.push(format);
      });
    }

    return formats;
  },
  filterFormatDefinitionsByDimensions: function filterFormatDefinitionsByDimensions(formats, dimensions) {
    if (!dimensions) {
      return formats;
    }

    var filteredFormats = [];

    formats.forEach(function (format) {
      var filteredDimensions = format.dimensions.filter(function (formatDimensions) {
        return formatDimensions.join('x') === dimensions;
      });

      if (filteredDimensions.length) {
        filteredFormats.push(_extends({}, format, { dimensions: filteredDimensions }));
      }
    });

    return filteredFormats;
  },
  getFormatDefinitionsBySlotName: function getFormatDefinitionsBySlotName(slotName) {
    var slot = this.getSlotDefinition(slotName);
    return this.getFormatDefinitionsBySlotDefinition(slot);
  },
  getGlobalRefreshRate: function getGlobalRefreshRate() {
    return getTopLevelAttribute('refreshRate');
  },
  isValidSlotForScreen: function isValidSlotForScreen(slotName, screenName) {
    if (!slotName) {
      return false;
    }

    if (!screenName) {
      return true;
    }

    var screen = this.getScreenDefinition(screenName) || this.getScreenDefinition('default');
    if (!screen) {
      return true;
    }

    var found = false;
    (0, _forEach2.default)(screen.slots, function (screenSlotName) {
      found = screenSlotName === slotName;
      return !found;
    });

    return found;
  }
};

module.exports = configUtils;